import React, { useState, useEffect } from "react";
import axios from "axios";
import "semantic-ui-css/semantic.min.css";
import { useAuth } from "../../../hook/userAuth";
import HeaderPage from "../../../components/HeaderPage/HeaderPage";
import ModalBasic from "../../../components/ModalBasic/ModalBasic";
import { AddEditCC } from "../../../components/CargosCategorias/AddEditCC";
import { Navigate } from "react-router-dom";
import { BASE_API } from "../../../ruta-server/BaseApi";
import { TableCargosCategorias } from "../../../components/CargosCategorias/TableCargosCategorias";
import { AddEditCategoria } from "../../../components/CargosCategorias/AddEditCategoria";
import { Loader } from "semantic-ui-react";
import Swal from "sweetalert2";

function CategoriasCargos() {
  const { auth } = useAuth();
  if (!auth?.me?.is_superuser) {
    return <Navigate to={"/"}></Navigate>;
  }
  return <LogicaCategoriasCargos />;
}

function LogicaCategoriasCargos() {
  const { auth } = useAuth();
  const [refetch, setRefetch] = useState(false);
  const [loading, setLoading] = useState(true);
  const [datos, setdatos] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [activeTab, setActiveTab] = useState("Cargos"); // Estado para rastrear la pestaña activa

  const openCloseModal = () => setShowModal((prev) => !prev);

  async function getCargos() {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_API}/api/cargo/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });

      const result = response.data;
      setLoading(false);
      setdatos(result);

      return result;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  async function getCategorias() {
    try {
      setLoading(true);
      const response = await axios.get(`${BASE_API}/api/categoria/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });

      const result = response.data;
      setLoading(false);
      setdatos(result);

      return result;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    if (activeTab === "Cargos") {
      getCargos();
    } else {
      getCategorias();
    }
    // eslint-disable-next-line
  }, [activeTab, refetch]);

  const onRefetch = () => {
    setRefetch((prev) => !prev);
  };

  const updateCargo = (data) => {
    setTitleModal("Actualizar cargo");
    setContentModal(
      <AddEditCC onClose={openCloseModal} onRefetch={onRefetch} cargo={data} />
    );
    openCloseModal();
  };

  const createCargo = () => {
    setTitleModal("Nuevo cargo");
    setContentModal(
      <AddEditCC onClose={openCloseModal} onRefetch={onRefetch} />
    );
    openCloseModal();
  };

  const updateCategoria = (data) => {
    setTitleModal("Actualizar categoría");
    setContentModal(
      <AddEditCategoria
        onClose={openCloseModal}
        onRefetch={onRefetch}
        categoria={data}
      />
    );
    openCloseModal();
  };

  const createCategoria = () => {
    setTitleModal("Nueva categoría");
    setContentModal(
      <AddEditCategoria onClose={openCloseModal} onRefetch={onRefetch} />
    );
    openCloseModal();
  };

  const deleteCategoria = async (datosCategoria) => {
    const confirmMessage = `<div>¿Seguro que desea eliminar esta categoria ${datosCategoria.descripcion}?</div>
    <div style="color: red;">Nota: Si hay usuarios que dependen de esta categoría, 
    no será eliminada aunque esta acción sea confirmada</div>`;

    const result = await Swal.fire({
      //title: '¿Estás seguro?',
      html: confirmMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      confirmButtonColor: "#2f6d02",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#920804",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          `${BASE_API}/api/categoria/${datosCategoria.id_categoria}/`,
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        );
        const result = response.data;
        onRefetch();
        return result;
      } catch (error) {}
    }
  };

  const deleteCargo = async (datosCargo) => {
    const confirmMessage = `<div>¿Seguro que desea eliminar esta cargo ${datosCargo.descripcion}?</div>
    <div style="color: red;">Nota: Si hay usuarios que dependen de este cargo, no será eliminada aunque esta acción sea confirmada</div>`;

    const result = await Swal.fire({
      //title: '¿Estás seguro?',
      html: confirmMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí",
      confirmButtonColor: "#2f6d02",
      cancelButtonText: "Cancelar",
      cancelButtonColor: "#920804",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(
          `${BASE_API}/api/cargo/${datosCargo.id_cargo}/`,
          {
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
          }
        );
        const result = response.data;
        onRefetch();
        return result;
      } catch (error) {}
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "Cargos":
        return (
          <>
            <HeaderPage btnTitulo="Registrar cargo" btnClick={createCargo} />
            {loading ? (
              <Loader active inline="centered">
                Cargando....
              </Loader>
            ) : (
              <TableCargosCategorias
                cargos={datos}
                updateCargo={updateCargo}
                deleteCargo={deleteCargo}
                encabezado="CARGO"
              />
            )}
            <ModalBasic
              show={showModal}
              title={titleModal}
              children={contentModal}
              close={openCloseModal}
            />
          </>
        );
      case "Categorias":
        return (
          <>
            <HeaderPage
              btnTitulo="Registrar categoría"
              btnClick={createCategoria}
            />
            {loading ? (
              <Loader active inline="centered">
                Cargando....
              </Loader>
            ) : (
              <TableCargosCategorias
                cargos={datos}
                updateCargo={updateCategoria}
                deleteCargo={deleteCategoria}
                encabezado="CATEGORÍA"
              />
            )}
            <ModalBasic
              show={showModal}
              title={titleModal}
              children={contentModal}
              close={openCloseModal}
            />
          </>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <h1 className="tituloin"> Cargos Y Categorías</h1>

      <div className="ui top attached tabular menu">
        <button
          className={`item ${activeTab === "Cargos" ? "active" : ""}`}
          onClick={() => setActiveTab("Cargos")}
        >
          <h1 className="subtituloin">Cargos</h1>
        </button>
        <button
          className={`item ${activeTab === "Categorias" ? "active" : ""}`}
          onClick={() => setActiveTab("Categorias")}
        >
          <h1 className="subtituloin">Categorias</h1>
        </button>
        <div className="right menu">
          <div className="item"></div>
        </div>
      </div>
      <div className="ui bottom attached segment">{renderContent()}</div>
    </div>
  );
}

export default CategoriasCargos;
